<template>
  <div>
    <div>
      <form @submit.prevent="submitForm">
        <div class="row">
          <div class="col-sm-12">
            <div>
              <BaseInput
                :inputType="'text'"
                v-model="formBody.cbaReference"
                placeholder="CBA Reference"
                :hasPreIcon="false"
                :label="'CBA Reference'"
                :class="{
                  error: $v.formBody.cbaReference.$error
                }"
                @blur="$v.formBody.cbaReference.$touch()"
              >
              </BaseInput>

              <template v-if="$v.formBody.cbaReference.$error">
                <p
                  v-if="!$v.formBody.cbaReference.required"
                  class="form-error-message"
                >
                  Cba Reference is required
                </p>
              </template>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="text-right">
              <span v-if="loader.actionButtonLoader" class="formLoaderHold">
                <BaseComponentLoader />
              </span>
              <span v-else>
                <button type="submit" class="btn btn-primary mr-1">
                  Submit
                </button>
              </span>
            </p>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import StoreUtils from "../../../../../utils/BaseUtils/StoreUtils";

export default {
  name: "ManualReversalForm",
  data() {
    return {
      formBody: this.freshFormBodyObject()
    };
  },
  computed: {
    ...mapState(["loader"])
  },
  validations: {
    formBody: {
      cbaReference: { required }
    }
  },

  methods: {
    submitForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        StoreUtils.dispatch(
          StoreUtils.actions.ft.MANUAL_REVERSAL,
          this.formBody
        );
      }
    },

    freshFormBodyObject() {
      return {
        source: "WEB"
      };
    }
  }
};
</script>

<style scoped></style>
